import { useState } from "react";
import { Loader2, MessageSquareQuote } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function FanQuoteForm({ slug, isFan }) {
  const { user } = useAuth();
  const [q, setQ] = useState(""); const [busy, setBusy] = useState(false); const [done, setDone] = useState(false);
  if (!user) return <a href={`/login?next=/premiere`} className="text-xs text-blue-300 hover:underline" data-testid="fan-quote-login">Fan Club member? Sign in to leave your one-line review</a>;
  if (!isFan) return <a href="/fan-club" className="text-xs text-blue-300 hover:underline" data-testid="fan-quote-join">Join the Fan Club to leave your one-line review after the early screening</a>;
  if (done) return <p className="text-xs text-emerald-300" data-testid="fan-quote-done">Thanks — your review is in for approval and will appear in the buzz strip.</p>;
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post(`/films/${slug}/fan-quotes`, { quote: q }); setDone(true); toast.success("Review submitted"); }
    catch (err) { toast.error(err?.response?.data?.detail || "Couldn't submit"); }
    finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="flex flex-wrap items-center gap-2" data-testid="fan-quote-form">
      <MessageSquareQuote className="w-4 h-4 text-blue-400" />
      <input value={q} onChange={(e) => setQ(e.target.value)} maxLength={140} minLength={12} required placeholder="Your one-line review from the early screening…" className="h-10 flex-1 min-w-[240px] rounded-md bg-[#131722] border border-[#222838] px-3 text-sm text-slate-200 placeholder:text-slate-600 focus:outline-none focus:border-blue-500" data-testid="fan-quote-input" />
      <button type="submit" disabled={busy || q.trim().length < 12} className="h-10 px-4 rounded-md bg-blue-500 text-white text-xs font-bold hover:bg-blue-600 disabled:opacity-50" data-testid="fan-quote-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Add my review"}</button>
      <span className="text-[10px] text-slate-500 w-full">{q.length}/140 · Fan Club members only · reviewed before it goes live</span>
    </form>
  );
}
